import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'

const HelmetFavicon = () => {
	const settings = useSelector((state) => state.settings)
	const { faviconISfile } = settings || {}

	const favicon = faviconISfile?.uri
	if (!favicon) return null

	return (
		<>
			<Helmet>
				<link rel='icon' type={favicon.type || 'image/png'} href={favicon.uri} sizes='192x192' />
			</Helmet>
		</>
	)
}

export default HelmetFavicon
